import { Injectable, signal } from "@angular/core";

/**
 * Styrer ServicePro-krom dynamisk (top-/bundnavigation, fuldskærm).
 * Sider sætter flags ved enter og rydder ved leave.
 */
@Injectable({ providedIn: "root" })
export class ServiceProChromeService {
    public readonly hideTopNavigation = signal(false);
    public readonly hideBottomNavigation = signal(false);
    public readonly fullBleed = signal(false);

    /**
     * @param active Kortside aktiv
     * @param options.hideTopNavigation Skjul top-banner (typisk kun på telefon)
     */
    public setMapPageChrome(active: boolean, options?: { hideTopNavigation?: boolean }): void {
        this.fullBleed.set(active);
        this.hideTopNavigation.set(active && !!options?.hideTopNavigation);
        if (!active) {
            this.hideBottomNavigation.set(false);
            this.hideTopNavigation.set(false);
        }
    }

    public setHideTopNavigation(hide: boolean): void {
        this.hideTopNavigation.set(hide);
    }

    public setHideBottomNavigation(hide: boolean): void {
        this.hideBottomNavigation.set(hide);
    }

    public reset(): void {
        this.hideTopNavigation.set(false);
        this.hideBottomNavigation.set(false);
        this.fullBleed.set(false);
    }
}
